import * as React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import NotificationDrawer, {
  NotificationTextBlock,
  NotificationsDrawerEmpty,
  NotificationRow,
  NotificationMarkRead,
} from './NotificationDrawer';

const Tip = styled.div`
  position: absolute;
  right: 10px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 20px 10px 20px;
  border-color: transparent transparent ${({ theme }) => theme.color.headerBackground} transparent;
`;

const DrawerOnScreen = styled.div`
  position: absolute;
  right: 0px;
  top: ${({ theme }) => theme.header.heightDesktop};
  width: 360px;
  background-color: ${({ theme }) => theme.color.headerBackground};
  border: 0px solid ${({ theme }) => theme.color.hr};
  border-left-width: 1px;
  border-bottom-width: 1px;
  border-bottom-left-radius: ${({ theme }) => theme.borderRadius.default};
  box-shadow: 22px 0 22px -22px rgba(124, 80, 0, 0.12), 0px 22px 22px -22px rgba(124, 80, 0, 0.12);
  z-index: 10;

  ${NotificationsDrawerEmpty} {
    text-align: center;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  ${NotificationRow}:hover ${NotificationMarkRead} {
    visibility: visible;
  }

  ${NotificationMarkRead} {
    visibility: hidden;
  }
`;

const NotificationDrawerAllNotifications = styled(NotificationTextBlock)`
  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
`;

const NotificationDrawerOnScreen = React.forwardRef<HTMLDivElement>((props, ref) => (
  <div>
    <Tip />
    <DrawerOnScreen ref={ref}>
      <NotificationDrawer />
      <NotificationDrawerAllNotifications>
        <Link className="non-text-link" to="/recent-activity">
          <button className="btn btn-sm btn-primary" type="button">
            All notifications
          </button>
        </Link>
      </NotificationDrawerAllNotifications>
    </DrawerOnScreen>
  </div>
));

export default NotificationDrawerOnScreen;
